module.exports = __webpack_public_path__ + "2020celebration/img/s6.7c658e48.png";